// IELTS Mock 4 — Academic Writing (line graph + advantages/disadvantages essay)
// Same shape as IELTS_DATA_WRITING in ../IeltsWriting.js. `mock` is forwarded to
// /api/scoring/writing-validate so it is checked against this mock's reference points.
const IELTS_MOCK4_WRITING = {
  title: "Academic Writing Practice Test 4",
  tasks: [
    {
      id: "task1",
      mock: 4,
      title: "Task 1: Report (20 min)",
      prompt:
        "The graph below shows the percentage of household waste that was recycled in three cities, Northfield, Eastport and Westbury, between 2000 and 2020. Summarise the information by selecting and reporting the main features, and make comparisons where relevant.",
      image: "/images/ielts-mock4/writing_task1_recycling.svg",
      minWords: 150,
      keywords: ["recycl", "waste", "household", "northfield", "eastport", "westbury", "percent", "proportion", "increas", "rose", "compar", "2000", "2020"],
      diagramType: "line"
    },
    {
      id: "task2",
      mock: 4,
      title: "Task 2: Essay (40 min)",
      prompt:
        "Nowadays, more and more people are working from home, using computers and the internet to communicate with their employers and colleagues. Do the advantages of this development outweigh the disadvantages? Give reasons for your answer and include any relevant examples from your own knowledge or experience.",
      minWords: 250,
      keywords: ["home", "work", "remote", "office", "employ", "colleague", "commut", "technology", "internet", "advantage", "disadvantage", "flexib", "isolat"]
    }
  ]
};

export default IELTS_MOCK4_WRITING;
